import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { GRID_INFORMATION } from 'shared/components/Disclaimer/constants';

export const InformationSection = styled(Box)(({ theme }) => ({
  gridArea: GRID_INFORMATION,
  padding: `${theme.spacing(2)} ${theme.spacing(3)} `,
  display: 'grid',
  rowGap: theme.spacing(2),
  overflow: 'auto',
}));
